import React from 'react';
import { C } from './dashboardConstants';

export const CalorieRing = ({ consumed, target }) => {
  const pct = Math.min(consumed / (target || 1), 1);
  const r = 42, circ = 2 * Math.PI * r;
  const dash = circ * pct;
  return (
    <svg width="100" height="100" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r={r} fill="none" stroke={C.border} strokeWidth="5" />
      <circle cx="50" cy="50" r={r} fill="none" stroke={C.accent} strokeWidth="5"
        strokeDasharray={`${dash} ${circ - dash}`} strokeLinecap="round"
        transform="rotate(-90 50 50)" style={{ transition: 'stroke-dasharray 1s ease-out' }} />
      <text x="50" y="46" textAnchor="middle" fill={C.text} fontSize="21" fontWeight="500"
        fontFamily="var(--font-sans)">{Math.round(consumed).toLocaleString()}</text>
      <text x="50" y="60" textAnchor="middle" fill={C.muted} fontSize="10"
        fontFamily="var(--font-sans)">of {target.toLocaleString()} cal</text>
    </svg>
  );
};
